export type AnyObject = {
  [key: string]: any
}

export const shallowCompare = (obj1: AnyObject, obj2: AnyObject) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every((key) => obj1[key] === obj2[key])
